import * as React from "react";
import { SVGProps } from "react";
const More = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <circle cx={2} cy={9} r={2} fill="currentColor" />
    <circle cx={9} cy={9} r={2} fill="currentColor" />
    <circle cx={16} cy={9} r={2} fill="currentColor" />
  </svg>
);
export default More;
